import {
    deleteHeaders,
    fetchHeaders,
    patchHeaders,
    postHeaders,
} from "../../utils/headers";
import Constants from "../../utils/constants";
import {toastHelper} from "../../utils/toast-helper";

export const heuresService = {
    fetchHeures,
    updateFeuilleDeTemps,
    fetchFicheChantier,
    exportSuiviHeures,
    fetchPeriodePaies,
    fetchPeriodePaie,
    createPeriodePaie,
    updatePeriodePaie,
    createPoste,
    fetchEquipageDetail,
    createEmptyFeuilleDeTemps,
    fetchFeuillesTempsHebdo,
    updatePosteOperateur,
    updateAlerteRH,
    fetchHeuresHebdoRh,
    createValidationSemaine,
    deleteValidationSemaine,
    createDeplacement,
    deleteDeplacement
};

function fetchHeures(startDate, endDate) {
    const requestOptions = fetchHeaders()

    let url = Constants.API_ROUTE_RH_SUIVI_HEURES;
    url = url.replace(":startDate", startDate)
    url = url.replace(":endDate", endDate)

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(heures => {
            return heures
        });
}

function updateFeuilleDeTemps(id, values) {
    const requestOptions = patchHeaders(values)

    let url = Constants.API_ROUTE_FEUILLEDETEMP;
    url = url.replace(":id", id)

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(heures => {
            return heures
        });
}

function fetchFicheChantier(startDate, endDate, operateurId) {
    const requestOptions = fetchHeaders()

    let url = Constants.API_ROUTE_RH_FICHE_CHANTIER;
    url = url.replace(":startDate", startDate)
    url = url.replace(":endDate", endDate)
    url = url.replace(":operateurId", operateurId)

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(ficheChantier => {
            return ficheChantier
        });
}

function exportSuiviHeures(start, end, mode = null) {
    const body = {start, end};
    if (mode) {
        body.mode = mode;
    }
    const requestOptions = postHeaders(body)

    let url = Constants.API_ROUTE_EXPORT_SUIVI_HEURES

    return fetch(url, requestOptions)
        .then(response => {
            if (!response.ok) {
                throw new Error(`Erreur ${response.status}: ${response.statusText}`);
            }
            if (mode === 'drive') {
                return response.json();
            }
            return response.blob(); // Retourne un fichier binaire (Blob)
        })
        .then(data => {
            if (mode === 'drive') {
                if (data.url) {
                    window.open(data.url, '_blank');
                    toastHelper.displaySuccess("L'export a été généré sur Google Drive.");
                } else {
                    toastHelper.displaySuccess("L'export a été généré sur Google Drive.");
                }
                return;
            }
            // Crée un lien de téléchargement
            const url = window.URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `fiche_suivi_${start}_${end}.xlsx`); // Nom du fichier
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link); // Nettoyage
        })
        .catch(error => {
            console.error('Erreur lors de l\'export du fichier Excel:', error);
        });
}

function fetchPeriodePaies() {
    const requestOptions = fetchHeaders()

    let url = Constants.API_ROUTE_PERIODE_PAIES;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data["hydra:member"]
        });
}

function fetchPeriodePaie(id) {
    const requestOptions = fetchHeaders()
    let url = Constants.API_ROUTE_PERIODE_PAIE;
    url = url.replace(":id", id)
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data
        });
}

function createPeriodePaie(values) {
    const requestOptions = postHeaders(values)

    let url = Constants.API_ROUTE_PERIODE_PAIES;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => {
            return "ok"
        });
}

function updatePeriodePaie(id, values) {
    const requestOptions = patchHeaders(values)

    let url = Constants.API_ROUTE_PERIODE_PAIE;
    url = url.replace(":id", id)

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => {
            return "ok"
        });
}

function deletePeriodePaie(id) {
    const requestOptions = deleteHeaders()

    let url = Constants.API_ROUTE_PERIODE_PAIE;
    url = url.replace(":id", id)

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => {
            return "ok"
        });
}

function createPoste(values) {
    const requestOptions = postHeaders(values)

    let url = Constants.API_ROUTE_RH_CREATE_FDT

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => {
            return "ok"
        });
}

function fetchEquipageDetail(posteOperateurId) {
    const requestOptions = fetchHeaders();

    let url = Constants.API_ROUTE_RH_EQUIPAGE_DETAIL;
    url = url.replace(":id", posteOperateurId);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(equipageDetail => {
            return equipageDetail;
        });
}

function createEmptyFeuilleDeTemps(operateurId, date, statutJournee, heureDebut, heureFin, tempsPauseMinutes) {
    const requestOptions = postHeaders({
        operateurId,
        date,
        statutJournee,
        heureDebut,
        heureFin,
        tempsPauseMinutes
    });

    let url = Constants.API_ROUTE_RH_CREATE_EMPTY_FDT;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function fetchFeuillesTempsHebdo(periodeId, operateurId) {
    const requestOptions = fetchHeaders();

    let url = Constants.API_ROUTE_RH_FEUILLES_TEMPS_HEBDO;
    let hasParam = false;

    if (periodeId) {
        url += `?periode_id=${periodeId}`;
        hasParam = true;
    }

    if (operateurId) {
        url += hasParam ? `&operateur_id=${operateurId}` : `?operateur_id=${operateurId}`;
        hasParam = true;
    }

    // Always request HS details to keep UI consistent with new API
    url += hasParam ? `&showHSDetails=true` : `?showHSDetails=true`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updatePosteOperateur(id, values) {
    const requestOptions = patchHeaders(values);

    let url = Constants.API_ROUTE_POSTE_OPERATEUR;
    url = url.replace(":id", id);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateAlerteRH(id, values) {
    const requestOptions = patchHeaders(values);

    let url = Constants.API_ROUTE_ALERTE_RH;
    url = url.replace(":id", id);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function fetchHeuresHebdoRh(periodeId) {
    const requestOptions = fetchHeaders();

    let url = Constants.API_ROUTE_RH_HEURES_HEBDO;
    if (periodeId) {
        url += `?periode_id=${periodeId}`;
    }

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function createValidationSemaine(operateurId, semaineDebut, commentaire = null) {
    const body = {operateurId, semaineDebut};
    if (commentaire) {
        body.commentaire = commentaire;
    }
    const requestOptions = postHeaders(body);

    let url = Constants.API_ROUTE_RH_VALIDATION_SEMAINE;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function deleteValidationSemaine(id) {
    const requestOptions = deleteHeaders();

    let url = Constants.API_ROUTE_RH_VALIDATION_SEMAINE_DELETE;
    url = url.replace(":id", id);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => {
            return "ok";
        });
}

function createDeplacement(operateurId, semaineDebut) {
    const requestOptions = postHeaders({operateurId, semaineDebut});

    let url = Constants.API_ROUTE_RH_DEPLACEMENTS;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function deleteDeplacement(id) {
    const requestOptions = deleteHeaders();

    let url = Constants.API_ROUTE_RH_DEPLACEMENT_DELETE;
    url = url.replace(":id", id);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => {
            return "ok";
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);

        if (!response.ok) {
            let errorMessage;

            if (data && data.message) {
                errorMessage = data.message;
            } else if (data && data.error) {
                errorMessage = data.error;
            } else if (data && typeof data === 'string') {
                errorMessage = data;
            } else {
                errorMessage = response.statusText || 'Une erreur est survenue';
            }

            return Promise.reject(errorMessage);
        }

        return data;
    });
}
